import { AgendaTxPatient } from "../interfaces/agenda.interface";
import { ButtonVariant } from "../components/core/button/button.component";
export const AppConstants = {
  //Dashboard task session Constants
  patient: "Patient",
  discipline: "Discipline",
  therapist: "Therapist",
  physician: "Physician",
  facility: "Facility",
  dateRange: "Date Range",
  SOCDate: "SOC Date",
  documentPendingSignatureTitle: "Documents Pending for Signature",
  documentRejectedSignatureTitle: "Documents Rejected for Signature",

  //Date range Names
  pastFourtyEightHours: "Past 48 Hours",
  lastDay: "Last Day",
  lastThreeDays: "Last 3 Days",
  lastWeek: "Last Week",
  lastOneWeek: "Last 1 Week",
  lastFourteenDays: "Last 14 Days",
  lastMonth: "Last Month",

  timedTypeCPTModalTitle: "Billed Timed Minutes",
  serviceTypeCPTModalTitle: "Billed Service Minutes",
  disabled: "Disabled",
  required: "Required",
  enabled: "Enabled",
  inviteSent: "Invite Sent",
  deleted: "Deleted",
  emDash: "—",
  notAvaialble: "N/A",
  defaultDate: "0001-01-01",
  disableDischargeMsg:
    "Please close the open therapy episode to provide Discharge Date.",
  nullValue: null,
  serviceBilledCPTCode: "N",
  dateSeperator: "-",
  rangeSeperator: "-/-",
  emptyString: "",
  NoneAvailable: "None Available",
  sessions: "sessions",
  days: "days",
  defaultDateFormat: "MM-dd-yyyy",
  MMDDYYYY: "MM/dd/yyyy",
  PT : 'PT',
  OT : 'OT',
  ST : 'ST',
  doublehyphen : "--",
  YYMMDDHHMMSS: "yyyy-MM-dd HH:mm:ss",
  YYMMDD: "yyyy-MM-dd",
  DMYYYYhMMSSA: "D/M/YYYY, h:mm:ss a",
  excludeFromAlerts: "Exclude from Alerts",
  customToday: "custom-today",
  select: "Select",
  effectivestartdate: "effectivestartdate",
  effectiveenddate: "effectiveenddate",
  startdate: "startdate",
  enddate: "enddate",
  StringText: "string",
  Z: "Z",
  noAgenda: "No Agenda",
  billed: "Billed",
  agenda: "Agenda",
  notBilled: "Not Billed",
  note: "Note",
  noDataFound: "No results found",
  None: "none",
  cannotBeDeleted: "Cannot Be Deleted",
  ok: "OK",
  name: "name",
  ASC: "ASC",
  DESC: "DESC",
  dob: "dob",
  delete: "Delete",
  cancel: "Cancel",
  enable: "Enable",
  disable: "Disable",
  notAllowed: "Not allowed",
  arrowdown: "keyboard_arrow_down",
  arrowup: "keyboard_arrow_up",
  error: "Error",
  close: "Close",
  warning: "Warning",
  T: "T",

  // security permissions
  manage: "M",
  none: "N",
  view: "V",
  zeroValue: 0,

  // eSig Status
  pending: "Pending",
  active: "Active",

  //labourhours
  labourHoursTitle: "Total Labor Hours (Salary)",

  //overtime
  overTimeTitle: "Over Time Configurations",
  //productivity
  productivityTitle: "Productivity Benchmark",
  facilityProductivityTitle: "Facility Productivity Benchmark",
  userProductivityTitle: "User Productivity Benchmark",
  corpDefaultOvertimetype: 2,
  corpDefaultOvertimeHRS: 40,
  corpDefaultWeekTimeLine: 1,
  corpDefaultLabourHrPeriod: 2,
  corpDefaultLabourHrValue: 40,
  corpDefaultProductivity: 80,
  defaultSearchLength: 3,
  millisecondsPerSecond: 1000,
  secondsPerMinute: 60,
  minutesPerHour: 60,
  hoursPerDay: 24,
  daysPerWeek: 7,
  millisecondsPerDay: 1000 * 60 * 60 * 24,
  millisecondsPerWeek: 1000 * 60 * 60 * 24 * 7,

  merge: 'merge',
  
  alerts: 'Alerts',
  lookbackperiod: 'Lookback Period',
  selectdate: 'Select Date',
  daterangSeperator : '/\s*-\s*/',

   // User Rate Exception IDs
   UserRateExceptions: {
    DoNotAllowImpersonate: 1,
    ExcludeFromScheduling: 2, 
    ExcludeFromPayroll: 3,
    ExcludeFromProductivity: 4,
    TimeClockIntegrationOverride: 5
  },

  //agenda status options
  AllAgendaItems: "all",
  ALL: "All",
  Active: "Active",
  InActive: "Inactive",
  Unassigned: "Unassigned",
  AgendaRowDisabled: "ag-row-disabled",
  Removeaction: "Remove",
  InActiveAction: "In-Activate",
  ActivateAction: "Activate",
  skipSpinner: "X-Skip-Spinner",
  forceSpinner: 'X-Force-Spinner',
  AllDisciplines: "PT / OT / ST",

  SORT_OPTIONS: {
    LABELS: {
      ASC: "Sort A-Z",
      DESC: "Sort Z-A",
    },
  },

  PR_QUESTIONS: {
    SKILLED_THERAPY_PROVIDED: {
      PATIENT_PROGRESS_STATUS: "SkilledCareAndAssessment_SkilledTherapyProvided_PatientProgressStatus",
    },
    SKILLED_CARE: {
      FOCUS_OF_ACTIVITIES: "SkilledCareAndAssessment_SkilledCare_Main_FocusOfActivities",
      ACTIVITIES_CHANGES: "SkilledCareAndAssessment_SkilledCare_Main_ActivitiesChanges",
      NEW_APPROACHES_FOR_FOCUS: "SkilledCareAndAssessment_SkilledCare_Main_NewApproachesForFocus",
      PURPOSE_OF_TREATMENT_VALUES: "SkilledCareAndAssessment_SkilledCare_Main_PurposeOfTreatmentValues",
    },
  },

  TX_AGENDA_BY_THERAPIST: "TX Agenda By Therapist",
  SELECT_THERAPIST: "Select Therapist",
  ASSIGN: "Assign",
  SELECT_ALL: "Select All",
  NO_UNASSIGNED_PATIENTS: "No unassigned patients",
  TOTAL_TREATMENT_HOURS: "Total Treatment Hours",
  TOTAL_SCHEDULED_TIME: "Total Scheduled Time",
  TOTAL_LABOR_ALLOWED: "Total Labor Allowed",
  NO_RESULTS_FOUND: "No results found",
  SEARCH_THERAPIST: "Search therapist",
  UNSAVED_CHANGES: "Unsaved Changes",
  SAVE_BEFORE_CLOSING: "You have unsaved changes. Save before closing?",
  SAVE_AND_CLOSE: "Save and Close",
  DISCARD_AND_CLOSE: "Discard and Close",
  DISCARD_CHANGES: "Discard Changes",
  CONTINUE_EDITING: "Continue Editing",
  ASSIGNMENT_MISMATCH: "Assignment Mismatch",
  NO_SELECTION: "No Selection",
  PLEASE_SELECT_PATIENT: "Please select at least one patient to assign",
  ARE_YOU_SURE_DISCARD: "Are you sure you want to discard all changes?",

  TIME_FORMAT_HM: "{0}h {1}m",
  TIME_FORMAT_PADDED_MINUTE: "{0}h {1}m",
  ASSIGNMENT_MISMATCH_TEMPLATE: (therapistName: string, therapistDisciplines: string, incompatibleCount: number, incompatibleList: string, compatibleCount: number) => `
    <div class="text-left">
      <div class="font-bold mb-2">Therapist ${therapistName} is only qualified for: ${therapistDisciplines}</div>
      
      <div class="mb-2">${incompatibleCount} patient(s) cannot be assigned:</div>
      <div class="pl-4 mb-3">${incompatibleList}</div>
      
      <div>${compatibleCount} compatible patient(s) will still be assigned.</div>
    </div>
  `,
  Save: "Save",
  SaveAndExit: "Save and Exit",
  Open: "open",
  sidebar: "sidebar",
  AgendaDate: "Agenda Date",
  UNASSIGNED_PREFIX: "unassigned-",
  THERAPIST_PREFIX: "therapist-",
  NoDataReports: "No data found for the report generation",
  DefaultPrintError: "Print error. Please use the report module to print schedule at this time.",
  NoAgendaForTheDay: "No Agenda is present for the day",
  DISCIPLINE_MISMATCH: {
    TITLE: "Discipline Mismatch",
    MESSAGE_TEMPLATES: {
      ASSIGN_TO_THERAPIST: (therapistName: string, therapistDisciplines: string, incompatibleCount: number, incompatibleList: string, compatibleCount: number) => `
        <div class="text-left">
          <div class="font-bold mb-2">Therapist ${therapistName} is only qualified for: ${therapistDisciplines}</div>
          
          <div class="mb-2">${incompatibleCount} patient(s) cannot be assigned:</div>
          <div class="pl-4 mb-3">${incompatibleList}</div>
          
          ${compatibleCount > 0 ? 
            `<div>${compatibleCount} compatible patient(s) will still be assigned.</div>` : 
            ''}
        </div>
      `,
      CANNOT_MOVE_BETWEEN_DISCIPLINES: (incompatibleCount: number, incompatibleList: string, targetDiscipline: string) => `
        <div class="text-left">
          <div class="mb-2">${incompatibleCount} patient(s) cannot be moved to ${targetDiscipline} section:</div>
          <div class="pl-4 mb-3">${incompatibleList}</div>
          <div>Patients must stay within their discipline's unassigned section.</div>
        </div>
      `,
      PATIENT_LIST: (patients: AgendaTxPatient[]) => `
        <ul class="list-disc pl-4">
          ${patients.map(p => `<li>${p.patientname}</li>`).join('')}
        </ul>
      `
    }
  },

  CONTRACT_WARNING_DIALOG: {
      TITLE: "Your contract is not finalized",
      MESSAGES: {
        DRAFT_INFO: " Your contract has not been finalized. Without an active<br> contract, you will <strong>not</strong> be able to:",
        RESTRICTIONS: [
          "Set or change a payor",
          "Initiate a treatment or an Evaluation & Plan of Care"
        ],
        DRAFT_QUESTION: "Do you still wish to save as a draft? If you wish to finalize your contract instead, click ‘Finalize Contract.’",
        INCOMPLETE_QUESTION: "Your contract is incomplete and unable to be finalized. Do you wish to continue without finalizing your contract?"
      },
      BUTTONS: {
        SAVE_DRAFT: { text: 'Save as Draft', variant: ButtonVariant.SECONDARY },
        FINALIZE: { text: 'Finalize Contract', variant: ButtonVariant.PRIMARY },
        CANCEL: { text: 'Cancel', variant: ButtonVariant.SECONDARY_OUTLINE },
        SAVE_NO_FINALIZE: { text: 'Save without Finalizing', variant: ButtonVariant.PRIMARY }
      }
  },
  PATIENT_LIST_HEADER: (discipline: string) => 
  `<p><strong>${discipline} Patients:</strong></p>`,
  TREATMENT_AGENDA_TITLE: "Treatment Agenda",
  DISCIPLINE_LABEL: "Discipline",
  STATUS_LABEL: "Status",
  THERAPISTS_LABEL: "Therapists",
  PRINT: "Print",
  OPTIONS: "Options",
  ADD_PATIENT: "Add Patient",
  CREATE_GROUP: "Create Group",
  SYNC_AGENDA: "Sync Agenda",
  CANCEL: "Cancel",
  CONTINUE: "Continue",
  TX_BY_THERAPIST: "Tx By Therapist",
  Success:"Success",

  UNASSIGNED_ID: "unassigned_id",
  Mode: "Mode",
  ADD_DISCIPLINE: "Add Discipline",
  disciplineControl:"discipline",
  therapistControl:"therapist",
  modeControl:"mode",
  disciplineIds:"disciplineIds",
  viewedExperiment: "Viewed Experiment",

  // Error Config
  Error_Config: (message: string) => {
    return {
      title: AppConstants.error,
      message: message,
      buttonText: AppConstants.close,
      hideCancelButton: true,
      isError: true,
    };
  },
  deleteUserErrorMessage: "An error occurred while deleting the user"
};

export const entityKeys = {
  patient: "patient",
  therapist: "therapist",
  billing: "billing",
  profile: "profile",
  billingdate: "billingdate",
  disciplineid: "disciplineid",
  user: "user",
  reports: "reports",
};

export const keys = {
  tabKey: "Tab",
};

export const UnknownQuestionnaireAndQuestionIdmappings = [
  {
    questionnaireId: "MedicalInformation_DischargeEnvironmentalAndPlan_Main",
    questionId: "MedicalInformation_DischargeEnvironmentalAndPlan_Main_TypeSummary"
  },
  {
    questionnaireId: "CMHAndDCPlan_DischargeEnvironmentalAndPlan_Main",
    questionId: "CMHAndDCPlan_DischargeEnvironmentalAndPlan_Main_TypeSummary"
  }
];

export const ValidationErrorKeys = {
  REQUIRED: 'required',
  WHITESPACE: 'whitespace',
  EMAIL: 'email',
  REQUIRED_PATTERN: 'requiredPattern',
  PATTERN_ERROR: 'patternError',
  PATTERN: 'pattern',
  MIN_LENGTH: 'minlength',
  MAX_LENGTH: 'maxlength',
  MIN: 'min',
  MAX: 'max',
  CUSTOM_VALIDATOR: 'customValidator',
  VALUE_MISMATCH: 'valueMismatch'
};

export const ValidationMessages = {
  required: () => 'Required',
  email: () => 'Email is invalid',
  invalidFormat: () => 'Invalid format',
  
  // Dynamic messages expecting inputs
  minLength: (length: number | string) => `Minimum ${length} characters
      required`,
      
  maxLength: (length: number | string) => `Maximum ${length} characters
      allowed`,
      
  min: (min: number | string) => `Minimum value should be ${min}`,
  
  max: (max: number | string) => `Maximum value should be ${max}`,
};

export const PaginationConstants = {
  pageSizeLabel: "Page Size:",
  showing: "Showing",
  pageCountStatus: (showing: number, total: number) => `${showing} of ${total} results`
}

export const FormControlErrorKeys = {

}